<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator="/">
      <el-breadcrumb-item :to="{ path: '/welcome' }">主页</el-breadcrumb-item>
      <el-breadcrumb-item :to="{ path: '/studentList'}">在读学员</el-breadcrumb-item>
      <el-breadcrumb-item>导入双师学生</el-breadcrumb-item>
    </el-breadcrumb>

    <!-- 内容卡片 -->
    <el-card>
      <!-- 操作提示 -->
      <div class="import-tip">
        <span>从双师系统选择需要导入的学生</span>
      </div>

      <!-- 学生列表 -->
      <el-table
        :data="vipssStudentList"
        stripe
        @selection-change="handleSelectionChange"
      >
        <!-- 复选框列 -->
        <el-table-column type="selection" width="55" :selectable="isSelectable"></el-table-column>

        <!-- 学生信息列 -->
        <el-table-column label="手机号码" prop="phone" width="150"></el-table-column>
        <el-table-column label="姓名" prop="realname" width="120"></el-table-column>
        <el-table-column label="分组" prop="groupName"></el-table-column>

        <!-- 状态列 -->
        <el-table-column label="状态" width="120">
          <template slot-scope="scope">
            <el-tag
              :type="scope.row.joinFlag == 1 ? 'danger' : 'success'"
              size="small"
            >
              {{ scope.row.joinFlag == 1 ? '已存在' : '可导入' }}
            </el-tag>
          </template>
        </el-table-column>
      </el-table>
      <!-- 操作按钮 -->
      <div class="action-buttons">
        <el-button
          type="primary"
          @click="handleImport"
          :disabled="selectedStudents.length === 0"
          icon="el-icon-upload"
        >
          导入选中学生 ({{ selectedStudents.length }})
        </el-button>
        <el-button @click="goBack">返回</el-button>
      </div>
    </el-card>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        // 双师学生列表
        vipssStudentList: [],
        // 总记录数
        total: 0,
        // 已选中的学生
        selectedStudents: []
      };
    },
    created() {
      this.loadVipssStudents();
    },
    methods: {
      // 加载双师学生数据
      async loadVipssStudents() {
        try {
          const { data: res } = await this.$http.post(
            "/ea/student/student/getVipssStudentList"
          );
          if (res.code !== 200) {
            this.$message.error(res.message || "获取双师学生列表失败");
            return;
          }
          this.vipssStudentList = res.result;
        } catch (error) {
          this.$message.error("加载双师学生失败，请重试");
        }
      },

      // 处理选择变化
      handleSelectionChange(selection) {
        this.selectedStudents = selection;
      },

      // 检查是否可选择
      isSelectable(row) {
        return row.joinFlag == 0;
      },
      async handleImport() {
        if (this.selectedStudents.length === 0) {
          this.$message.warning("请至少选择一个学生进行导入");
          return;
        }

        // 提取所需字段构建新对象数组
        const studentData = this.selectedStudents.map(student => ({
          phone: student.phone,
          realname: student.realname,
          groupName: student.groupName // 分组名称
        }));

        try {
          const { data: res } = await this.$http.post(
            "/ea/student/student/importVipss",
            { students: studentData } // 参数名改为语义化复数形式
          );

          if (res.code === 200) {
            this.$message.success(`导入学生`);
            this.loadVipssStudents(); // 刷新列表
            this.selectedStudents = []; // 清空选择
          } else {
            this.$message.error(res.msg || "导入失败");
          }
        } catch (error) {
          console.error("导入请求异常:", error);
          this.$message.error("网络请求失败");
        }
      },
      // 返回上一页
      goBack() {
        this.$router.go(-1);
      }
    }
  };
</script>

<style lang="less" scoped>
  .import-tip {
    margin-bottom: 20px;
  }

  .action-buttons {
    margin-top: 30px;
    text-align: center;

    .el-button {
      min-width: 180px;
      padding: 12px 24px;
      font-size: 16px;
    }
  }

  .el-table {
    /deep/ .el-table__row {
      .el-tag {
        margin: 2px 0;
      }

      // 禁用行的样式
      &.disabled-row {
        cursor: not-allowed;
        background-color: #f5f7fa;

        .el-checkbox {
          cursor: not-allowed;
        }
      }
    }
  }
</style>
